import { render, staticRenderFns } from "./FiveCrowns.vue?vue&type=template&id=019547ee&"
import script from "./FiveCrowns.vue?vue&type=script&lang=js&"
export * from "./FiveCrowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FiveCrowns.vue"
export default component.exports